<mat-drawer-container id="close" class="sk-drawer-container">
    <mat-drawer #drawer1 class="example-sidenav sk-mat-drawer-main-body" mode="over" [opened]="drawer1$ | async" position="end">
        <div class="sk-drawer-body">
            <ng-template #wmDynamicViewRef></ng-template>
        </div>
    </mat-drawer>
</mat-drawer-container>


<app-background-overlay-drawer [isOpen]="(drawerLayout$ | async) || false"></app-background-overlay-drawer>
